import BaseViewController from "./base-view-controller";

class ConsultationBhScheduleViewController extends BaseViewController {
  preprocessScreenData() {
    const { values } = this.appData;

    const communicationMethodField = this.screen.fields.find(
      field => field.name === "communication_method"
    );
    if (communicationMethodField) {
      communicationMethodField.options.forEach(option => {
        option.hidden = values.phone_only ? option.name !== "PHONE" : false;
      });
    }
  }

  handleButtonClick(name, text, action) {
    if (this.screen.name === "MessageCenterBhSchedule") {
      super.handleButtonClick(name, text, action, 3);
    } else {
      super.handleButtonClick(name, text, action);
    }
  }
}

export default ConsultationBhScheduleViewController;
